import styled from 'styled-components';

export const BannerRoot = styled.div`
  position: relative;
  border-radius: ${({ theme }) => theme.radiusSm};
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontFamily};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadowCard};
  width: 100%;
`;

export const BannerLink = styled.a`
  display: block;
  position: relative;

  img {
    width: 100%;
    display: block;
    object-fit: cover;
    height: ${({ $variant }) => ($variant === 'inline' ? '96px' : '112px')};

    @media (min-width: 768px) {
      height: ${({ $variant }) => ($variant === 'inline' ? '104px' : '144px')};
    }
  }
`;

export const BannerOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.15);
  opacity: 0;
  transition: opacity 0.2s;

  ${BannerLink}:hover & {
    opacity: 1;
  }
`;

export const DismissBtn = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 12px);
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  z-index: 2;

  &:hover {
    background: rgba(0, 0, 0, 0.75);
  }
`;

export const BadgeRow = styled.div`
  position: absolute;
  bottom: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1;
  pointer-events: none;
`;

export const AdBadge = styled.span`
  padding: 0.2rem 0.5rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 14px);
  background: rgba(0, 0, 0, 0.58);
  color: #fff;
  font-size: ${({ theme }) => theme.fontClamp.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const SponsorText = styled.span`
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
`;
